
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#593289","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M3.393 4.167h13.214l-1.064 13.16a2 2 0 01-1.993 1.84H6.423a2 2 0 01-1.994-1.844L3.393 4.167h0zm4.941 9.999V8.333m3.333 5.833V8.333m-10-4.167h16.667"}}),_c('path',{attrs:{"stroke-linejoin":"round","d":"M6.569 3.627v-2.5h6.667v2.5"}})])])
          )
        }
      }
    